import { headers } from 'next/headers'
import { redirect } from 'next/navigation'
import { createClient } from '@/lib/supabase/server'
import Link from 'next/link'
import Image from 'next/image'
import { SignOutButton } from '@/components/sign-out-button'
import { NotificationBell } from '@/components/notification-bell'
import { FeedbackWidget } from '@/components/feedback-widget'

export default async function AuthenticatedLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const supabase = await createClient()
  const { data: { user } } = await supabase.auth.getUser()

  if (!user) {
    // Allow signup pages through without auth — the worker/contractor signup
    // pages live inside the (authenticated) route group but must be accessible
    // immediately after signup, before the server-side session cookie may be
    // fully established. The middleware already permits this (isProtected && !isSignup).
    const headersList = await headers()
    const pathname = headersList.get('x-pathname') || ''
    if (pathname.includes('/signup')) {
      return <>{children}</>
    }

    redirect('/auth/login')
  }

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-50 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="mx-auto flex h-14 max-w-screen-xl items-center justify-between px-4">
          <Link href="/dashboard">
            <Image src="/logo_black.svg" alt="RateRight" width={120} height={34} className="h-7 w-auto" />
          </Link>
          <div className="flex items-center gap-2 ml-4">
            <span className="text-sm text-muted-foreground truncate hidden sm:inline">{user.email}</span>
            <NotificationBell />
            <SignOutButton />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Feedback Widget */}
      <FeedbackWidget />
    </div>
  )
}
